"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMultiLineHtmlText = exports.parseNoteWithBlockquote = exports.kebabToCamel = exports.camelToKebab = exports.capitalizeFirstLetter = exports.removeAccents = exports.simpleHash = void 0;
const tslib_1 = require("tslib");
const sanitize_html_1 = tslib_1.__importDefault(require("sanitize-html"));
/**
 * Returns a hash code from a string
 * @param str The string to hash.
 * @return A 32bit integer converted to string
 */
function simpleHash(str) {
    let hash = 0;
    for (let i = 0, len = str.length; i < len; i++) {
        let chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash | 0; // Convert to 32bit integer
    }
    return String(hash);
}
exports.simpleHash = simpleHash;
/**
 * Strips combining diacritics (Unicode NFD) so e.g. é → e, ô → o.
 */
function removeAccents(str) {
    try {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    catch {
        return str;
    }
}
exports.removeAccents = removeAccents;
function capitalizeFirstLetter(string) {
    return string ? string[0].toUpperCase() + string.slice(1) : '';
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
exports.camelToKebab = camelToKebab;
function kebabToCamel(str) {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
}
exports.kebabToCamel = kebabToCamel;
/**
 * Parses a note string that may contain a markdown blockquote (lines starting with "> ").
 * Returns the quote block (with "> " stripped) and the rest as message.
 */
function parseNoteWithBlockquote(text) {
    if (!text || typeof text !== 'string')
        return { quote: null, message: text || '' };
    const paragraphs = text.split(/(?:\n\r?|\r\n?){2,}/);
    const first = paragraphs[0]?.trim() ?? '';
    const lines = first.split(/\n\r?|\r\n?/);
    const allQuoteLines = lines.length > 0 && lines.every(line => /^>\s?/.test(line.trim()));
    if (!allQuoteLines)
        return { quote: null, message: text };
    const quote = lines.map(line => line.replace(/^>\s?/, '').trim()).join('\n');
    const message = paragraphs.slice(1).join('\n\n').trim();
    return { quote, message };
}
exports.parseNoteWithBlockquote = parseNoteWithBlockquote;
function formatMultiLineHtmlText(text) {
    if (!text)
        return text;
    const sanitizedText = (0, sanitize_html_1.default)(text, { allowedTags: ['b'] });
    return sanitizedText
        .replace(/(\s*(?:\n\r?|\r\n?)\s*){2,}/g, `<div class="u-half-break"></div>`)
        .replace(/(?:\n\r?|\r\n?)/g, '<br>');
}
exports.formatMultiLineHtmlText = formatMultiLineHtmlText;
//# sourceMappingURL=index.js.map